import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideHttpClient, withInterceptors, HttpClient } from '@angular/common/http';
import { GlobalErrorHandler } from '../@core/handlers/global-error.handler';
import { acceptLanguageInterceptor } from '../@core/interceptors/accept-language.interceptor';
import { errorInterceptor } from '../@core/interceptors/error.interceptor';
import { LanguageService } from '../@core/services/language.service';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/**
 * Factory function for TranslateHttpLoader
 * Loads translation files from public/i18n/
 */
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      // Language first so the header is set before error handling logs anything
      withInterceptors([acceptLanguageInterceptor, errorInterceptor])
    ),
    provideRouter(appRoutes,
      withComponentInputBinding(), // enable component input binding
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled', // enable position restoration
        anchorScrolling: 'enabled', // enable anchor scrolling
      }),
    ),
    // Configure ngx-translate
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'nb',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    ),
    // Instantiate LanguageService at bootstrap: without it the stored locale is
    // never applied on pages that lack a language selector (/callback, /thank-you).
    provideAppInitializer(() => {
      inject(LanguageService);
    }),
    // default to NOK whenever you use | currency without a code
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'NOK' },
    // Global error handler
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
  ],
};
